import React from "react";
import logo from "./logo.svg";
import "./App.css";
import MiniGame from "./components/MiniGame";

function App() {
  return (
    <div className="App">
      <main>
        <MiniGame />
      </main>
    </div>
  );
}

export default App;
